import { CHART_TEXT } from '../constants';

import { formatDateTimeForTooltip } from './dateFormatHelpers';

interface TooltipFormatterContext {
	score: number;
	date: string;
}

/**
 * Creates tooltip HTML content for accessibility chart
 */
export const createTooltipContent = (score: number, dateString: string): string => {
	const { date } = formatDateTimeForTooltip(dateString);
	return `${CHART_TEXT.TOOLTIP.SCORE_LABEL} ${score}<br/> ${CHART_TEXT.TOOLTIP.DATE_LABEL} ${date}`;
};

/**
 * Tooltip formatter function for Highcharts
 * This function is bound to the chart context when called
 */
export function tooltipFormatter(): string {
	if (this != null) {
		const point = this as TooltipFormatterContext;
		return createTooltipContent(point.score, point.date);
	}

	return '';
}
